import { IconCreditCard, IconPercent, IconTruck } from '@gazin/ecommerce-ui'
import { useMemo, useState } from 'react'
import {
  arePixOrBilletAvailable,
  getInCashAvailablePaymentMethods,
} from 'src/util/payment'
import { usePaymentMethod } from '../../contexto/hooks/usePaymentMethod'
import * as S from './styles'

const IconSeguranca = '/images/svg/icon-seguranca.svg'

const GAZIN_CREATED_YEAR = 1965
const GAZIN_CREATED_MONTH = 12
const GAZIN_CREATED_DAY = 13

function SetorInformacao({ darkTheme }) {
  const [age, setAge] = useState()
  const { payment } = usePaymentMethod()

  const maxInstallments = payment?.creditCard?.numero_parcela ?? 1;

  const gazinAge = useMemo(() => {
    const now = new Date()
    const month = now.getMonth() + 1

    let age = now.getFullYear() - GAZIN_CREATED_YEAR

    const decreaseAYear =
      month < GAZIN_CREATED_MONTH ||
      (month == GAZIN_CREATED_MONTH && now.getDate() < GAZIN_CREATED_DAY)

    if (decreaseAYear) {
      age--
    }

    return age
  }, [])

  return (
    <S.SectionInfoPagamentoGeral darkTheme={darkTheme}>
      <S.Content>
        <S.Card>
          <S.IconContainer>
            <IconCreditCard
              width={{ base: '1.375rem', md: '3.1875rem' }}
              height={{ base: '1.5625rem', md: '2.3125rem' }}
              variant="blue"
            />
          </S.IconContainer>
          <S.Text>
            <span>
              Pague em até <S.TextBold>{maxInstallments}x</S.TextBold> no cartão de
              crédito
            </span>
          </S.Text>
        </S.Card>
        {arePixOrBilletAvailable(payment) && (
          <S.Card>
            <S.IconContainer>
              <IconPercent
                width={{ base: '1.375rem', lg: '2.625rem' }}
                height={{ base: '1.5625rem', lg: '2.6875rem' }}
              />
            </S.IconContainer>
            <S.Text>
              <span>
                <strong>Desconto</strong> para pagamentos{' '}
                <strong>
                  à vista no {getInCashAvailablePaymentMethods(payment)}
                </strong>
              </span>
            </S.Text>
          </S.Card>
        )}
        <S.Card>
          <S.IconContainer>
            <IconTruck
              width={{ base: '1.375rem', md: '2.875rem' }}
              height={{ base: '1.5625rem', md: '2.3125rem' }}
            />
          </S.IconContainer>

          <S.Text>
            <span>
              Entregamos em <strong>todo Brasil!</strong>
            </span>
          </S.Text>
        </S.Card>
        <S.Card>
          <S.IconContainer>
            <S.Image
              src={IconSeguranca}
              alt="Compra Segura"
              className="icon"
              width={34}
              height={39}
            />
          </S.IconContainer>

          <S.Text>
            <span>
              Compra 100% segura! <strong>{gazinAge} anos de história</strong>
            </span>
          </S.Text>
        </S.Card>
      </S.Content>
    </S.SectionInfoPagamentoGeral>
  )
}
export default SetorInformacao
